import React from 'react';

const DonationFile = (props) => {
    if(props.currentDonation) {
        return (
        <span style={{cursor: 'pointer'}} onClick={() => props._onHandleDownloadFile(props.currentDonationId, props.currentDonationName)}>{props.currentDonationName}
        {props.attached && <span style={{fontSize: '0.8em'}}> (Tilknyttet)</span>}
        </span>)
    } else if (props.file) {
        return (<span>{props.file.name}</span>)
    } else {
        return null;
    }
}

export default DonationFile;


// WEBPACK FOOTER //
// ./src/modules/reports/DonationFile.js